import { CubeTransparentIcon } from "@heroicons/react/24/outline";

const NoUsageDisclaimer = () => {
  return (
    <div className="mt-5 flex flex-col items-center justify-center text-center bg-yellow-50 border border-yellow-200 rounded-xl p-6 shadow-sm">
      <CubeTransparentIcon className="h-10 w-10 text-yellow-500 mb-4" />
      <h2 className="text-lg font-semibold text-yellow-800 mb-2">
        No Usage Data Available
      </h2>
      <p className="text-sm text-yellow-700 max-w-md">
        You don’t have enough activity to generate usage reports yet. Create a
        pipeline and start a run to begin tracking your usage metrics. Once your
        jobs are completed, usage reports will appear here.
      </p>
    </div>
  );
};

export default NoUsageDisclaimer;
